import { defineMessages } from 'react-intl';

export default defineMessages({
    thisFieldMustBeUnique: {
        id: 'policycommon.directives.schedules.dataItem.This field must be unique',
        defaultMessage: 'This field must be unique'
    },
    requiredField: {
        id: 'policycommon.directives.schedules.dataItem.This is a required field',
        defaultMessage: 'This is a required field'
    }
});
